import React from 'react'

const CustomDivider = () => {
  return (
    <div className='w-9 h-1 bg-light-secondary rounded-full m-auto my-1 '>
      
    </div>
  )
}

export default CustomDivider
